import React from 'react';
import { Meeting } from '../types';
import { getWeekDays, weekDays } from '../utils';
import AgendaMeeting from './AgendaMeeting';

interface AgendaViewProps {
  currentDate: Date;
  meetings: Meeting[];
  currentTimezone: string;
  onMeetingClick: (meeting: Meeting) => void;
}

const AgendaView: React.FC<AgendaViewProps> = ({
  currentDate,
  meetings,
  currentTimezone,
  onMeetingClick,
}) => {
  return (
    <div className="flex flex-col h-full">
      {/* Fixed header */}
      <div className="sticky top-0 z-30 grid grid-cols-7 gap-px bg-gray-200 border-b dark:bg-gray-700 dark:border-gray-600">
        {getWeekDays(currentDate).map((date) => (
          <div
            key={date.toISOString()}
            className="bg-white p-2 text-center text-sm font-medium text-gray-500 dark:bg-gray-800 dark:text-gray-400"
          >
            <div>{weekDays[date.getDay()]}</div>
            <div
              className={`mt-1 ${
                date.toDateString() === new Date().toDateString()
                  ? 'bg-blue-500 text-white dark:bg-blue-600 w-6 h-6 rounded-full flex items-center justify-center mx-auto'
                  : ''
              }`}
            >
              {date.getDate()}
            </div>
          </div>
        ))}
      </div>

      {/* Scrollable content */}
      <div className="grid grid-cols-7 gap-px bg-gray-200 dark:bg-gray-700 h-full">
        {getWeekDays(currentDate).map((date) => (
          <div key={date.toISOString()} className="bg-white dark:bg-gray-800 p-2 min-h-[200px]">
            {meetings
              .filter((meeting) => new Date(meeting.starts_at).toDateString() === date.toDateString())
              .sort((a, b) => new Date(a.starts_at).getTime() - new Date(b.starts_at).getTime())
              .map((meeting) => (
                <AgendaMeeting key={meeting.id} meeting={meeting} onMeetingClick={onMeetingClick} />
              ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default AgendaView;
